<ion-header translucent>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(taskProcessContext.from || taskProcessContext.site) && !taskProcessContext.isCRMMode"
      slot="start">
      <ion-button (click)="onBackClicked($event)" class="back-button">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <div (click)="taskProcessContext.from && openUserProfile()" class="avatar-name-and-site">
      <app-avatar [src]="taskProcessContext.from?.avatarURL" class="avatar-thumbnail"></app-avatar>
      <div class="name-and-site">
        <div class="name alc-ellipsis">
          <span>{{
            taskProcessContext.from?.name ||
              ('engagement/send-message/choose-sender-recipient/unknown-user' | translate)
          }}</span>
          <span *ngIf="taskProcessContext.from?.handle"> - {{ taskProcessContext.from.handle }} </span>
          <app-vip-bullet *ngIf="taskProcessContext.from?.isVIP"></app-vip-bullet>
        </div>
        <app-site-icon-and-name
          class="engagement"
          *ngIf="taskProcessContext.engagement; else legacySite"
          [item]="taskProcessContext.site">
          {{ $any(taskProcessContext.site)?.label }}
        </app-site-icon-and-name>
        <ng-template #legacySite>
          <app-site-icon-and-name [site]="$any(taskProcessContext.site)"></app-site-icon-and-name>
        </ng-template>
      </div>
      <div class="alc-spacer"></div>
      <div class="logo-and-text">
        <div class="powered-by">Powered by<br />Alcméon</div>
        <div class="alc-alcmeon-logo-bg"></div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
